export default "__VITE_ASSET__536048be__"